export default __webpack_public_path__ + "media/images/icon_settings.png";